import { useState } from "react";
import { X } from "lucide-react";
import { PRIORITIES, CATEGORIES } from "./constants";

const EMPTY = { tab: "labels", targetName: "", company: "", role: "", category: "A&R", priority: "Medium", soundFitNotes: "", publicContactRoute: "", email: "", cityNotes: "", comments: "" };

export default function AddContactDialog({ open, defaultTab, onClose, onCreate }) {
  const [form, setForm] = useState({ ...EMPTY, tab: defaultTab });
  if (!open) return null;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    if (!form.targetName.trim()) return;
    onCreate(form);
    setForm({ ...EMPTY, tab: defaultTab });
  };
  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <div className="fixed inset-0 z-[80] grid place-items-center p-4 pointer-events-none">
        <form onSubmit={submit} className="card w-full max-w-xl p-6 pointer-events-auto rise" style={{ background: "rgba(23,26,38,0.97)", backdropFilter: "blur(20px)" }} data-testid="add-contact-dialog">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-extrabold">Add outreach target</h2>
            <button type="button" className="btn btn-sm" onClick={onClose} data-testid="add-dialog-close-button"><X size={14} /></button>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <label className="col-span-2"><div className="eyebrow mb-1.5">Target name *</div><input className="input" required value={form.targetName} onChange={set("targetName")} data-testid="add-name-input" /></label>
            <label><div className="eyebrow mb-1.5">Company / Label</div><input className="input" value={form.company} onChange={set("company")} data-testid="add-company-input" /></label>
            <label><div className="eyebrow mb-1.5">Role</div><input className="input" value={form.role} onChange={set("role")} /></label>
            <label><div className="eyebrow mb-1.5">Tab</div>
              <select className="select" value={form.tab} onChange={set("tab")} data-testid="add-tab-select"><option value="labels">Labels & A&R</option><option value="management">Management & Booking</option></select></label>
            <label><div className="eyebrow mb-1.5">Category</div><select className="select" value={form.category} onChange={set("category")}>{CATEGORIES.map((c) => <option key={c}>{c}</option>)}</select></label>
            <label><div className="eyebrow mb-1.5">Priority</div><select className="select" value={form.priority} onChange={set("priority")} data-testid="add-priority-select">{PRIORITIES.map((c) => <option key={c}>{c}</option>)}</select></label>
            <label><div className="eyebrow mb-1.5">Email (public / professional only)</div><input className="input mono" value={form.email} onChange={set("email")} /></label>
            <label className="col-span-2"><div className="eyebrow mb-1.5">Sound fit notes</div><input className="input" value={form.soundFitNotes} onChange={set("soundFitNotes")} /></label>
            <label className="col-span-2"><div className="eyebrow mb-1.5">Public contact route</div><input className="input" value={form.publicContactRoute} onChange={set("publicContactRoute")} /></label>
            <label className="col-span-2"><div className="eyebrow mb-1.5">City / ADE presence</div><input className="input" value={form.cityNotes} onChange={set("cityNotes")} /></label>
          </div>
          <div className="flex justify-end gap-2 mt-5">
            <button type="button" className="btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-amber" data-testid="add-submit-button">Add target</button>
          </div>
        </form>
      </div>
    </>
  );
}
